import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import GetIcon from "../font-awesome-icon";
import { faCopy , faCheckCircle } from "@fortawesome/free-regular-svg-icons";


const CopyButton = ({
  value,
  variant,
  copySpecificText,
  title = "",
  styles = {},
  valueStyle = {},
  showValue = true,
  icon = faCopy,
}) => {
  const [copyValue, setCopyValue] = useState(false);

  const copyText = (e) => {
    e.stopPropagation();
    setCopyValue(true);
  };

  return (
    <span
      style={{ ...styles }}
      onMouseLeave={() => {
        setCopyValue(false);
      }}
    >
      {showValue ? (
        value ? (
          <span style={{ ...valueStyle }}>{value}</span>
        ) : (
          "N/A"
        )
      ) : null}
      {value &&
        (!copyValue ? (
          <CopyToClipboard text={copySpecificText || value}>
            <GetIcon
              title={title}
              icon={icon}
              iconStyles={{
                marginLeft: "3px",
                cursor: "pointer",
                fontSize: "0.9rem",
                color: "var(--palette-secondary_button_text)",
              }}
              onClick={(e) => copyText(e)}
            />
          </CopyToClipboard>
        ) : (
          <span title="Copied">
            <GetIcon
              title={title}
              icon={faCheckCircle}
              iconStyles={{
                marginLeft: "3px",
                marginBottom: "3px",
                cursor: "pointer",
                fontSize: "0.9rem",
                color: "var(--palette-success)",
              }}
            />
          </span>
        ))}
    </span>
  );
};

export default CopyButton;
